import { render, staticRenderFns } from "./PluginListPanel.vue?vue&type=template&id=44d16e50&scoped=true"
import script from "./PluginListPanel.vue?vue&type=script&lang=ts"
export * from "./PluginListPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "44d16e50",
  null
  ,true
)

export default component.exports